import axios from "axios";
// "http://192.168.1.86:8089"+
const base = process.env.BASE;

function loginReq(params) {
    let params1 = new URLSearchParams({
        'loginName': params.uname,
        'password': params.upwd,
        'validateCode': params.vrfc,
        'codeuuid': params.codeuuid
    })
    console.log(params1, "打印");
    return axios.post(base + "/login", params1);
}

function getVerifyCodeUrl() {
    return base + '/getVerifyCode?' + new Date().getTime();
}

function checkIE() {
    return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
}

function login(a, b, c) {
    var lang = 'zh_CN';
    // var lang = 'en_US';
    return $.ajax({
            type: "POST",
            url: base + '/login?lang=' + lang,
            processData: false,
            contentType: false
        })
        // return
        // return axios.post(base + '/login?lang=' + lang,{loginName:a,password:b,validateCode:c})
}
//       return axios.post(base + '/login?lang=' + lang,{loginName:a,password:b,validateCode:c})
function hasAuth() {
    // return axios.post(base + '/hasAuth');
}

function crcc16Url() {
    return axios.get(base + '/common/crcc16Url');
}

function crcc16LogOutUrl() {
    return axios.get(base + '/common/crcc16LogOutUrl');
}

function logout() {
    return axios.get(base + '/logout?' + new Date().getTime());
}
// 分中心
function logoutNewFtpPath() {
    return axios.get(base + '/common/logoutNewFtpPath');
}

function logout1(logoutURL) {

    return $.ajax({
        type: "POST",
        dataType: "jsonp",
        url: logoutURL,
        processData: false,
        contentType: false
    })
}

export default {
    getVerifyCodeUrl,
    hasAuth,
    logout,
    base,
    checkIE,
    logout1,
    loginReq,
    crcc16Url,
    crcc16LogOutUrl,
    logoutNewFtpPath
}



// WEBPACK FOOTER //
// ./src/assets/js/login.js